import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react'
import Appbar from './Appbar';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import "../Assets/CSS/BnbConnect.css"


const WithdrawalReport = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate();
    const [sellData, setSellData] = useState([]);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

  return (
    <div className='bnbcontainer'>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Appbar handleDrawerToggle={handleDrawerToggle} />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                        <Grid item md={2}>
                            <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        </Grid>
                        <Grid item xs={12} md={10} sx={{ mt: "70px" }}>
                            <Grid container spacing={3} p={3}>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", padding: "15px", borderRadius: "10px" }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <div className='headerconn'>
                                                    <div className='dashbheading'
                                                        onClick={() => {
                                                            navigate("/dashboard")
                                                        }}
                                                    >Dashboard</div>
                                                    <div className='subheading'>
                                                        / Withdrawal Report
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", borderRadius: "20px" }}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12} >
                                                <div className='topuptitle'>Withdrawal Report</div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <hr />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Grid container spacing={2} sx={{ paddingLeft: "30px", paddingRight: "30px", paddingBottom: "30px", paddingTop: "10PX" }}>
                                                    <Grid item xs={12} md={12} >
                                                        <TableContainer>
                                                            <Table aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow >
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Sr.No</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Wallet Address</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>BNB Amount</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Date</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {sellData.length > 0 ? (
                                                                        sellData.map((item, index) => (
                                                                            <TableRow
                                                                                key={index}
                                                                                sx={{
                                                                                    borderBottom: "1px solid white",
                                                                                }}
                                                                            >
                                                                                <TableCell sx={{ color: "white", textAlign: "center" }}>
                                                                                    {index + 1}
                                                                                </TableCell>
                                                                                <TableCell sx={{ color: "white", textAlign: "center" }}>
                                                                                    {item.token}
                                                                                </TableCell>
                                                                                <TableCell sx={{ color: "white", textAlign: "center" }}>
                                                                                    {item.bnb}
                                                                                </TableCell>
                                                                                 <TableCell sx={{ color: "white", textAlign: "center" }}>
                                                                                    {item.date}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))
                                                                    ) : (
                                                                        <TableRow>
                                                                            <TableCell
                                                                                colSpan={4} 
                                                                                sx={{
                                                                                    color: "white",
                                                                                    textAlign: "center",
                                                                                    py: 2,
                                                                                }}
                                                                            >
                                                                                No level claim records found
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
        </div>
  )
}

export default WithdrawalReport